import _ from "lodash";
import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ProduktinstruktionUtils } from "../services/produktinstruktionUtils";
import { IProduktdefinition } from "./IProduktdefinition";
import { IProduktdefinitionBasdata, ITradslagsgrupp } from "./ProduktdefinitionModels";
export class ProduktdefinitionHeaderData {
    id?: number;
    namn: string;
    handelssortiment: string;
    sortiment: string;
    puid: string;
    tradslagsgrupp: ITradslagsgrupp;
    tradslagsgruppId: string;
    mottagningsplats: string;
    mottagningsplatsViol3: string;
    produktgrupp: string;
    version: string;
    produkt: string;
    beskrivning: string;
    skapadDatum: string;
    andradDatum: string;
    skapadAv: string;
    regioner: string[];
    maxlangd: number;
    maxdiameter: number;
    pinEnbartForSimulering: boolean;

    constructor(model: IProduktdefinition, basdata: IProduktdefinitionBasdata) {
        this.id = model.id;
        this.namn = model.namn;
        this.handelssortiment = model.handelssortiment;
        this.puid = model.puid;
        this.tradslagsgrupp = model.tradslagsgrupp;
        this.tradslagsgruppId = model.tradslagsgruppId;
        this.sortiment = model.sortiment;
        this.mottagningsplats = model.mottagningsplats;
        this.produktgrupp = model.produktgrupp;
        this.version = model.version;
        this.produkt = model.produkt;
        this.beskrivning = model.beskrivning;
        this.mottagningsplatsViol3 = model.mottagningsplatsViol3;
        this.skapadDatum = !ObjectUtils.isNullOrUndefined(model.skapadDatum) ? DateUtils.shortDateString(model.skapadDatum) : undefined;
        this.andradDatum = DateUtils.shortDateString(model.andradDatum);
        this.skapadAv = model.skapadAv;
        this.maxlangd = model.maxlangd;
        this.maxdiameter = model.maxdiameter;
        this.pinEnbartForSimulering = model.pinEnbartForSimulering;
        this.mapRegioner(model, basdata);

    }

    mapToDto(model: IProduktdefinition) {
        model.namn = this.namn;
        model.handelssortiment = this.handelssortiment;
        model.sortiment = this.sortiment;
        model.puid = this.puid;
        model.tradslagsgrupp = this.tradslagsgrupp;
        model.tradslagsgruppId = this.tradslagsgrupp?.gruppId;
        model.mottagningsplats = this.mottagningsplats;
        model.produktgrupp = this.produktgrupp;
        model.version = this.version;
        model.produkt = this.produkt;
        model.beskrivning = this.beskrivning;
        model.mottagningsplatsViol3 = this.mottagningsplatsViol3;
        model.version = this.version;
        model.maxlangd = this.maxlangd;
        model.maxdiameter = this.maxdiameter;
        model.pinEnbartForSimulering = this.pinEnbartForSimulering;
        model.regioner = ProduktinstruktionUtils.removeMarknadsomraden(this.regioner);
    }

    private mapRegioner(model: IProduktdefinition, basdata: IProduktdefinitionBasdata) {
        this.regioner = model.regioner;

        // För att få träd-selektorn att se "bra" ut så lägger vi manuellt till marknadsområdesnoden så att den blir checked
        // om det är så att samtliga underliggande resultatområden är checkade.
        _.chain(basdata.regioner.filter(x => x.aktiv))
            .groupBy(g => g.marknadsomradeId)
            .map((regioner, marknadsomradeId) => {
                // Om alla regioner i ett särskilt marknadsområde finns så lägger vi till ett sådant element till vymodellen "manuellt"
                if (_.difference(regioner.map(s => s.id), this.regioner).length === 0) {
                    return ProduktinstruktionUtils.fakeMarknadsomradeGuid(marknadsomradeId);
                }
                return null;
            })
            .filter(f => f !== null)
            .value()
            .forEach(x => this.regioner.push(x));
    }
}
